import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

export function AppIconBank({ size = 20, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_TEXT_PRIMARY

  return (
    <Svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <Path
        fill={fill}
        d="M8.85254 1.65103C9.57487 1.28998 10.4251 1.28998 11.1475 1.65103L17.333 4.74381C17.9867 5.07065 18.4001 5.7387 18.4004 6.46941C18.4004 7.44545 17.675 8.25033 16.7344 8.37957V13.6042C17.2718 13.9103 17.6952 14.4064 17.9004 15.0212V15.0222L17.9883 15.2849C18.3626 16.4074 17.5268 17.5671 16.3438 17.5671H3.65625C2.47317 17.5671 1.63758 16.4073 2.01172 15.2849L2.09961 15.0222V15.0212C2.30491 14.406 2.72865 13.9093 3.2666 13.6032V8.37957C2.32551 8.25074 1.59961 7.44577 1.59961 6.46941C1.5999 5.73867 2.01338 5.07064 2.66699 4.74381L8.85254 1.65103ZM4.53418 15.0671C4.20465 15.0673 3.91214 15.2781 3.80762 15.5905L3.74902 15.7663H16.251L16.1924 15.5905C16.0879 15.2781 15.7954 15.0673 15.4658 15.0671H4.53418ZM8.40039 13.2663H11.5996V8.40008H8.40039V13.2663ZM13.4004 13.2663H14.9336V8.40008H13.4004V13.2663ZM5.06738 13.2663H6.59961V8.40008H5.06738V13.2663ZM10.3428 3.26041C10.1272 3.15274 9.87281 3.15274 9.65723 3.26041L3.47168 6.35319C3.42787 6.37512 3.40068 6.42046 3.40039 6.46941C3.40039 6.53958 3.45586 6.59666 3.52539 6.59929H5.06738V6.60027H6.59961V6.59929H8.40039V6.60027H11.5996V6.59929H13.4004V6.60027H14.9336V6.59929H16.4746C16.5442 6.59666 16.5996 6.53958 16.5996 6.46941C16.5993 6.42044 16.5721 6.37511 16.5283 6.35319L10.3428 3.26041Z"
      />
    </Svg>
  )
}
